import React from 'react';
import { AlertTriangle, Info, Calendar } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/Components/ui/accordion";

interface Note {
    type: string;
    title: string;
    message: string;
    dates: string;
}

interface NotesProps {
    notes: Note[];
}

const Notes: React.FC<NotesProps> = ({ notes }) => {
    const getIcon = (type: Note['type']) => {
        switch (type) {
            case 'Safety':
                return <AlertTriangle className="w-5 h-5 text-red-500" />;
            case 'General':
                return <Info className="w-5 h-5 text-blue-500" />;
            case 'Event':
                return <Calendar className="w-5 h-5 text-green-500" />;
            default:
                return <Info className="w-5 h-5 text-blue-500" />;
        }
    };

    const getTypeColor = (type: Note['type']) => {
        switch (type) {
            case 'Safety':
                return 'text-red-800 bg-red-100';
            case 'General':
                return 'text-blue-800 bg-blue-100';
            case 'Event':
                return 'text-green-800 bg-green-100';
            default:
                return 'text-blue-800 bg-blue-100';
        }
    };

    return (
        <div className="w-full mt-8">
            <Accordion type="single" collapsible defaultValue="notes">
                <AccordionItem value="notes">
                    <AccordionTrigger className="bg-mint px-6 py-4 rounded-lg hover:no-underline hover:bg-mint/90">
                        <h2 className="text-2xl font-bold">Things To Note</h2>
                    </AccordionTrigger>
                    <AccordionContent className="pt-6">
                        <div className="space-y-4">
                            {notes.map((note, index) => (
                                <div key={index} className="bg-white rounded-lg p-4 shadow">
                                    <div className="flex items-center gap-2 mb-3">
                                        <span className={`px-3 py-1 rounded-full text-sm font-semibold flex items-center ${getTypeColor(note.type)}`}>
                                            {getIcon(note.type)}
                                            <span className="ml-1">{note.type}</span>
                                        </span>
                                        <span className="text-lg font-semibold">{note.title}</span>
                                    </div>
                                    <p className="mb-3">{note.message}</p>
                                    <p className="text-sm text-gray-600">
                                        <span className="font-semibold">Applies:</span> {note.dates}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </AccordionContent>
                </AccordionItem>
            </Accordion>
        </div>
    );
};

export default Notes;